import { isOnClient } from '@growth/ssr-utils';

function gtmPush(obj) {
  if (!isOnClient) return;

  if (window && !window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(obj);
}

export default gtmPush;
